import { PropsWithChildren } from "react";
import classNames from "classnames";

import { Paragraph } from "components/Paragraph/Paragraph";
import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";

import styles from "./styles.module.scss";

type RadioButtonProps = PropsWithChildren<{
  id: string;
  text: string;
  name: string;
  onChange: VoidFunction;
  checked: boolean;
  value: string | number;
  defaultChecked?: boolean;
  className?: any;
}>;

const RadioButton = (props: RadioButtonProps): JSX.Element => {
  const {
    id,
    text,
    name,
    onChange,
    checked,
    className,
    value,
    defaultChecked,
  } = props;

  return (
    <label
      htmlFor={id}
      className={classNames(styles.radioButtonLabel, className)}
    >
      <input
        className={styles.radiobuttonInput}
        type="radio"
        name={name}
        id={id}
        value={value}
        onChange={onChange}
        checked={checked}
        defaultChecked={defaultChecked}
      />
      <span className={styles.customRadioButton} />
      <HorizontalSpace size={12} />
      <Paragraph>{text}</Paragraph>
    </label>
  );
};

export default RadioButton;
